import {css} from '@yandex-delivery/blocks/theme/css'

export const map = css`
  // иначе не оверрайдятся стили карты из blocks
  &&&& {
    display: flex;
    height: 100vh;
    width: 100vw;
  }
`
